import {
  Box,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  TextField
} from "@mui/material";
import { useFormikContext } from "formik";
import { PlanFormValues } from "../PlanFormValues";

export const RewardSettingsFields = () => {
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext<PlanFormValues>();

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("controls.payments.isEnabled", event.target.checked);
  };

  return (
    <>
      <Box>
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend">Reward Name</FormLabel>
          <TextField
            value={values.name}
            onChange={handleChange}
            name="name"
            required
            fullWidth
            size="small"
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
          />
        </FormControl>
        <FormControl sx={{ mt: 4 }} fullWidth>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <FormLabel component="legend">Can Send Rewards</FormLabel>
            <Switch
              checked={values.controls?.payments?.isEnabled || false}
              onChange={handleSwitchChange}
              name="controls.payments.isEnabled"
            />
          </Stack>
        </FormControl>
      </Box>
    </>
  );
};
